import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container } from './style';
import { Settings } from './Settings/Settings';
import { RoomsList } from './RoomsList';
import ModalContainer from '../../Modals/ModalContainer';
import { GymTvConfigurationsModal } from '../../../Components/Modals/GymTvConfigurationsModal';
import { chooseWhenToDisplayItems } from './utils';
import {
    getFirstWeekDay,
    getLastWeekDay,
    getFormattedDateFromMomentObject,
    getCurrentFormattedDate,
} from '../../../../Utils/timeConvertorHelper';
import { convertBooleansToNumbers, copyObject } from '../../../../Utils';
import { modalTypes } from './constants';
import debounce from 'lodash.debounce';
import { GymTvActionCreators } from '../../../../Store/ActionCreators/GymTvActionCreators';
import { WorkoutActionCreators } from '../../../../Store/ActionCreators/WorkoutsActionCreators';
import { timeFormats } from '../../../../Constants/timeFormats';

class AdminGymTv extends Component {
    state = {
        currentDate: getCurrentFormattedDate(timeFormats.SERVER_DATE_TYPE),
        modalSettings: {
            isModalOpen: false,
            modalKey: null,
        },
        cardSelected: {
            id: null,
        },
        roomSelected: {},
    };

    componentDidMount() {
        /*
            we get workout of the week by setting the first day of the week to the request
            also, we get workouts of the day by setting the date range
        */
        const firstWeekDay = getFormattedDateFromMomentObject(getFirstWeekDay(0), timeFormats.SERVER_DATE_TYPE);
        const lastWeekDay = getFormattedDateFromMomentObject(getLastWeekDay(0), timeFormats.SERVER_DATE_TYPE);

        this.props.getWorkoutsOfTheDay(firstWeekDay, lastWeekDay);
        this.props.getWorkoutOfTheWeek(firstWeekDay);
        this.props.getGymTvChannels();
    }

    inputRequestWithDelay = debounce(() => {
        this.updateGymTvChannel();
    }, 250);

    /*
        handlers for handling setting changes and modals
    */
    selectedRoomHandlers = () => ({
        handleInputChange: ({ target }) =>
            this.setState(
                prevState => ({ roomSelected: { ...prevState.roomSelected, [target.name]: target.value } }),
                () => this.inputRequestWithDelay(),
            ),

        handleCheck: ({ target }) =>
            this.setState(
                prevState => ({
                    roomSelected: { ...prevState.roomSelected, [target.name]: !prevState.roomSelected[target.name] },
                }),
                () => this.inputRequestWithDelay(),
            ),

        handleDurationChange: newDuration =>
            this.setState(
                prevState => ({
                    roomSelected: { ...prevState.roomSelected, rotation_duration: newDuration },
                }),
                () => this.inputRequestWithDelay(),
            ),

        handleDisplayTimeChange: (type, newDisplayTime) => {
            let displayProperty = '';
            switch (type) {
                case modalTypes.BEFORE_CLASS: {
                    displayProperty = 'start_display';
                    break;
                }
                case modalTypes.AFTER_CLASS: {
                    displayProperty = 'end_display';
                    break;
                }

                default:
                    break;
            }

            this.setState(
                prevState => ({
                    roomSelected: { ...prevState.roomSelected, [displayProperty]: newDisplayTime },
                }),
                () => this.inputRequestWithDelay(),
            );
        },

        uploadBackgroundImage: e => {
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onloadend = () =>
                this.setState(
                    prevState => ({
                        ...prevState,
                        roomSelected: {
                            ...prevState.roomSelected,
                            background_preview: reader.result,
                        },
                    }),
                    () => this.updateGymTvChannel(),
                );

            if (file) {
                reader.readAsDataURL(file);
                this.setState(prevState => ({
                    ...prevState,
                    roomSelected: { ...prevState.roomSelected, background: file },
                }));
            }
        },

        openSelectModal: (modalKey, betweenItemIndex) =>
            this.setState(prevState => ({
                modalSettings: { ...prevState.modalSettings, isModalOpen: true, modalKey, betweenItemIndex },
            })),

        closeSelectModal: () =>
            this.setState(prevState => ({
                modalSettings: {
                    ...prevState.modalSettings,
                    isModalOpen: false,
                    modalKey: null,
                },
            })),

        selectDisplayItem: (displayType, displayItems) =>
            this.setState(
                prevState => {
                    if (displayType !== modalTypes.BETWEEN_CLASSES) {
                        const displayPropName = chooseWhenToDisplayItems(displayType);
                        let displayPropInfo = {};
                        if (prevState.roomSelected[displayPropName])
                            displayPropInfo = {
                                data: { ...prevState.roomSelected[displayPropName].data, ...displayItems },
                            };
                        else displayPropInfo = { data: { ...displayItems } };

                        return {
                            ...prevState,
                            roomSelected: {
                                ...prevState.roomSelected,
                                [displayPropName]: { ...displayPropInfo },
                            },
                        };
                    } else {
                        let betweenArray = [];
                        let dataArray = [];

                        if (prevState.roomSelected.between && prevState.roomSelected.between.data)
                            betweenArray = prevState.roomSelected.between.data;

                        if (betweenArray.length > prevState.modalSettings.betweenItemIndex) {
                            betweenArray[prevState.modalSettings.betweenItemIndex] = {
                                ...betweenArray[prevState.modalSettings.betweenItemIndex],
                                ...displayItems,
                            };
                            dataArray = [...betweenArray];
                        } else {
                            dataArray = [...betweenArray, displayItems];
                        }

                        return {
                            ...prevState,
                            roomSelected: {
                                ...prevState.roomSelected,
                                between: {
                                    data: [...dataArray],
                                },
                            },
                        };
                    }
                },
                () => {
                    this.setState({ modalSettings: { ...this.state.modalSettings, isModalOpen: false } });
                    this.addGymTvChannelItem(displayItems);
                },
            ),

        addBetweenClassesItem: () =>
            this.setState(prevState => ({
                ...prevState,
                roomSelected: {
                    ...prevState.roomSelected,
                },
            })),

        deleteDisplayItem: (displayType, displayItems, betweenIndex) => {
            switch (displayType) {
                case modalTypes.BEFORE_CLASS: {
                    this.setState({ roomSelected: { ...this.state.roomSelected, before: {} } }, () =>
                        this.props.deleteGymTvChannelItem(this.state.roomSelected.id, displayItems.id),
                    );
                    break;
                }

                case modalTypes.DURING_CLASS: {
                    this.setState({ roomSelected: { ...this.state.roomSelected, during: {} } }, () =>
                        this.props.deleteGymTvChannelItem(this.state.roomSelected.id, displayItems.id),
                    );
                    break;
                }

                case modalTypes.AFTER_CLASS: {
                    this.setState({ roomSelected: { ...this.state.roomSelected, after: {} } }, () =>
                        this.props.deleteGymTvChannelItem(this.state.roomSelected.id, displayItems.id),
                    );
                    break;
                }

                case modalTypes.BETWEEN_CLASSES: {
                    let betweenArray = [...this.state.roomSelected.between.data];
                    const itemToDelete = betweenArray[betweenIndex];

                    betweenArray.splice(betweenIndex, 1);

                    this.setState(
                        prevState => {
                            return {
                                ...prevState,
                                roomSelected: {
                                    ...prevState.roomSelected,
                                    between: {
                                        ...prevState.roomSelected.between,
                                        data: [...betweenArray],
                                    },
                                },
                            };
                        },
                        () => this.props.deleteGymTvChannelItem(this.state.roomSelected.id, itemToDelete.id),
                    );
                    break;
                }

                default:
                    break;
            }
        },
    });

    /*
        handlers for handling gym tv cards actions
    */
    roomHandlers = roomInfo => ({
        // start playing a channel
        onPlay: () => {
            const { match } = this.props;

            var win = window.open(`${match.url}/${roomInfo.id}`, '_blank');
            win.focus();

            // window.location.href = `${match.url}/${roomInfo.id}`;
        },

        // select channel to edit
        onEdit: () => this.setState({ roomSelected: roomInfo }),

        // duplicate channel
        onDuplicate: () => this.props.duplicateGymTvChannel(roomInfo.id),

        // delete channel
        onDelete: () => this.props.deleteGymTvChannel(roomInfo.id),

        // open/close input
        onInputToggle: () =>
            this.setState(prevState => {
                const { id, name } = roomInfo;
                return prevState.cardSelected.id
                    ? { cardSelected: { id: null, name: '' } }
                    : { cardSelected: { id, name } };
            }),

        // change name of a card
        onTitleChange: (name, id) => {
            if (this.state.roomSelected.id === id)
                this.setState(
                    prevState => ({
                        ...prevState,
                        roomSelected: {
                            ...prevState.roomSelected,
                            name,
                        },
                    }),
                    () => this.updateGymTvChannel(),
                );
            else this.updateGymTvChannelName(id, name);
        },
    });

    // post requests wrappers
    createNewChannel = () => this.props.createGymTvChannel();

    updateGymTvChannel = () => {
        const {
            roomSelected: { id, background_preview, ...channel },
        } = this.state;
        const newChannelInfo = convertBooleansToNumbers(channel);
        if (newChannelInfo.background && typeof newChannelInfo.background === 'string')
            delete newChannelInfo.background;

        this.props.updateGymTvChannel(id, newChannelInfo);
    };

    updateGymTvChannelName = (id, name) => {
        this.props.updateGymTvChannel(id, { name });
    };

    /*
        First, we have to check whether a display item has an id in order to update it
        If does - update, if does not - add new;
    */
    addGymTvChannelItem = itemData => {
        const {
            roomSelected: { id, before, during, after, between },
            modalSettings: { betweenItemIndex },
        } = this.state;

        let leaderboardIds = [];
        if (itemData.leaderboards) {
            leaderboardIds = itemData.leaderboards.data.map(lb => lb.id);
            itemData.leaderboard_ids = leaderboardIds;
            delete itemData.leaderboards;
        }

        switch (itemData.type) {
            case modalTypes.BEFORE_CLASS: {
                if (before.data.id) {
                    const channelItemId = before.data.id;
                    this.props.updateGymTvChannelItem(id, channelItemId, itemData);
                } else this.addChannelItem(id, itemData);
                break;
            }

            case modalTypes.DURING_CLASS: {
                if (during.data.id) {
                    const channelItemId = during.data.id;
                    this.props.updateGymTvChannelItem(id, channelItemId, itemData);
                } else this.addChannelItem(id, itemData);
                break;
            }

            case modalTypes.AFTER_CLASS: {
                if (after.data.id) {
                    const channelItemId = after.data.id;
                    this.props.updateGymTvChannelItem(id, channelItemId, itemData);
                } else this.addChannelItem(id, itemData);
                break;
            }

            case modalTypes.BETWEEN_CLASSES: {
                const bArray = [...between.data];

                if (bArray[betweenItemIndex].id) {
                    const channelItemId = between.data[betweenItemIndex].id;
                    this.props.updateGymTvChannelItem(id, channelItemId, itemData);
                } else this.addChannelItem(id, itemData);
                break;
            }

            default:
                break;
        }
    };

    /*
        Adding an id to the state
    */
    addChannelItem = (id, itemData) => {
        const {
            modalSettings: { betweenItemIndex },
        } = this.state;

        this.props.addGymTvChannelItem(id, itemData, itemId => {
            switch (itemData.type) {
                case modalTypes.BEFORE_CLASS: {
                    this.setState(prevState => ({
                        ...prevState,
                        roomSelected: {
                            ...prevState.roomSelected,
                            before: { data: { ...prevState.roomSelected.before.data, id: itemId } },
                        },
                    }));
                    break;
                }

                case modalTypes.DURING_CLASS: {
                    this.setState(prevState => ({
                        ...prevState,
                        roomSelected: {
                            ...prevState.roomSelected,
                            during: { data: { ...prevState.roomSelected.during.data, id: itemId } },
                        },
                    }));
                    break;
                }

                case modalTypes.AFTER_CLASS: {
                    this.setState(prevState => ({
                        ...prevState,
                        roomSelected: {
                            ...prevState.roomSelected,
                            after: { data: { ...prevState.roomSelected.after.data, id: itemId } },
                        },
                    }));
                    break;
                }

                case modalTypes.BETWEEN_CLASSES: {
                    this.setState(prevState => {
                        const betweenArray = copyObject(prevState.roomSelected.between.data);
                        betweenArray[betweenItemIndex].id = itemId;

                        return {
                            ...prevState,
                            roomSelected: {
                                ...prevState.roomSelected,
                                between: { data: [...copyObject(betweenArray)] },
                            },
                        };
                    });
                    break;
                }

                default:
                    break;
            }
        });
    };

    // today's workout of the day
    getTodaysWorkoutOfTheDay = () => {
        const { currentDate } = this.state;
        const { workoutsOfTheDay } = this.props;

        let currentWorkout = {};
        workoutsOfTheDay.forEach(workout => {
            if (workout.date === currentDate) currentWorkout = { ...workout.workout };
        });

        return currentWorkout;
    };

    render() {
        const {
            state: { roomSelected, cardSelected, modalSettings },
            props: { workoutOfTheWeek, channelsLoading, channels },
            selectedRoomHandlers,
            getTodaysWorkoutOfTheDay,
            roomHandlers,
            createNewChannel,
        } = this;
        const todaysWorkoutOfTheDay = getTodaysWorkoutOfTheDay();

        return (
            <Container>
                {modalSettings.isModalOpen && (
                    <ModalContainer>
                        <GymTvConfigurationsModal
                            onClose={selectedRoomHandlers().closeSelectModal}
                            onSelect={selectedRoomHandlers().selectDisplayItem}
                            onDurationChange={selectedRoomHandlers().handleDisplayTimeChange}
                            startDisplay={roomSelected.start_display}
                            endDisplay={roomSelected.end_display}
                            workoutsOfTheDay={todaysWorkoutOfTheDay}
                            workoutOfTheWeek={workoutOfTheWeek}
                            type={modalSettings.modalKey}
                        />
                    </ModalContainer>
                )}
                <RoomsList
                    channels={channels}
                    channelsLoading={channelsLoading}
                    cardSelected={cardSelected}
                    roomHandlers={roomHandlers}
                    onCreate={createNewChannel}
                />
                <Settings {...selectedRoomHandlers()} {...roomSelected} />
            </Container>
        );
    }
}

const mapStateToProps = ({
    workout: {
        statuses: { areWorkoutsOfTheDayLoading, isWorkoutOfTheWeekLoading },
        workoutsOfTheDay,
        workoutOfTheWeek,
    },
    gymTv: {
        statuses: { channelsLoading },
        channels,
    },
}) => ({
    areWorkoutsOfTheDayLoading,
    isWorkoutOfTheWeekLoading,
    workoutsOfTheDay,
    workoutOfTheWeek,

    channelsLoading,
    channels,
});

const mapDispatchToProps = dispatch => ({
    getWorkoutsOfTheDay: (start, end) =>
        dispatch(WorkoutActionCreators.getWorkoutsOfTheDayByDateRangeRequest(start, end)),
    getWorkoutOfTheWeek: mondayDate => dispatch(WorkoutActionCreators.getWorkoutOfTheWeekRequest(mondayDate)),
    getGymTvChannels: () => dispatch(GymTvActionCreators.getGymTvChannelsRequest()),
    createGymTvChannel: () => dispatch(GymTvActionCreators.createGymTvChannelRequest()),
    updateGymTvChannel: (channelId, channelData) =>
        dispatch(GymTvActionCreators.updateGymTvChannelRequest(channelId, channelData)),
    duplicateGymTvChannel: channelId => dispatch(GymTvActionCreators.duplicateGymTvChannelRequest(channelId)),
    deleteGymTvChannel: channelId => dispatch(GymTvActionCreators.deleteGymTvChannelRequest(channelId)),
    addGymTvChannelItem: (channelId, itemData, callback) =>
        dispatch(GymTvActionCreators.addGymTvChannelItemRequest(channelId, itemData, callback)),
    updateGymTvChannelItem: (channelId, itemId, itemData) =>
        dispatch(GymTvActionCreators.updateGymTvChannelItemRequest(channelId, itemId, itemData)),
    deleteGymTvChannelItem: (channelId, itemId) =>
        dispatch(GymTvActionCreators.deleteGymTvChannelItemRequest(channelId, itemId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AdminGymTv);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/index.js